export enum TradeInStatus {
    COMPLETED = 'completed',
    UNFINISHED = 'unfinished',
}

export enum TradeInStep {
    SEARCH = 1,
    FORM = 2,
    CONFIRMATION = 3,
    CONFIRMED = 4,
    NOT_STARTED = 5,
}

export const TRADE_IN_SESSION_KEY = 'mobile_recovery_current_product';
